import React, { PropsWithChildren } from "react";
import { instance } from "services/analytics";
import { _MatomoContextProvider } from "./MatomoContext";

export const MatomoContextProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <_MatomoContextProvider value={instance}>{children}</_MatomoContextProvider>
);
